// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"262":"css/app.7046","8802":"css/admin-app.7046"}[chunkId] + ".css";
};